module.exports = __webpack_public_path__ + "media/images/logos/pinterest-df87cbc74692a7b7622fada5087b6f5b.svg";